// Static demo data for the Question Result screen.
// Same "options" list is reused by both the User poll and the Panel poll -
// only the vote counts differ between the two audiences.

const questionResult = {
  id: 101,
  question: "Which soft tissue structure is most commonly released last as a resort during correction in total knee replacement?",
  correctOptionId: "opt2",

  options: [
    { id: "opt1", label: "Iliotibial band" },
    { id: "opt2", label: "Popliteus tendon" },
    { id: "opt3", label: "Lateral collateral ligament" },
    { id: "opt4", label: "Lateral capsule" },
  ],

  userPoll: {
    votes: {
      opt1: 10,
      opt2: 3,
      opt3: 5,
      opt4: 0,
      opt5: 0,
    },
  },

  panelPoll: {
    votes: {
      opt1: 2,
      opt2: 4,
      opt3: 1,
      opt4: 0,
      opt5: 0,
    },
  },
};

export default questionResult;
